// @flow
import React from "react";
import {strings} from "../../../config";
import TechnicalIssue from "../../TechnicalIssue/TechnicalIssue";

type OwnProps = {||};

const BlockingError = (props: OwnProps) => {
    return (
        <TechnicalIssue labels={[strings.blocking_technical_issue_text]}/>
    );
};

export default BlockingError;



// WEBPACK FOOTER //
// ./src/Components/Screen/BlockingError/BlockingError.js